import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import ChannelKey from '@avtechsoftware/ra-javascript-utilities/src/classes/ChannelKey';
import {
  AlertFormSteps,
  selectNameAlertData,
  selectSensorsData, updateStepData,
} from '../../../../redux/slices/alertFormSlice/alertFormSlice';
import AdditionalSensor from '../../../alerts/AlertForms/AdditionalSensor/AdditionalSensor';
import AddAdditionalSensorModal from './AddAdditionalSensorModal';

function AlertFormAdditionalSensors() {
  const dispatch = useDispatch();
  const selectedSensorsData = useSelector(selectSensorsData);
  const nameAlertData = useSelector(selectNameAlertData);
  const [showAddSensorModal, setShowAddSensorModal] = useState(false);

  const additionalSensors = nameAlertData.additionalSensors || [];
  const isMultipleSensors = selectedSensorsData.selectedChannels.length > 1;

  const handleRemoveSensor = (indexToRemove) => {
    const newSensorsList = additionalSensors.filter((_, idx) => idx !== indexToRemove);
    dispatch(updateStepData({
      step: AlertFormSteps.NAME_ALERT,
      data: { additionalSensors: newSensorsList },
    }));
  };

  const handleAddSensor = (newChannelKeyObj) => {
    const newChannelKey = newChannelKeyObj.fullChannelKey;
    const newSensorsList = [...additionalSensors, newChannelKey];
    dispatch(updateStepData({
      step: AlertFormSteps.NAME_ALERT,
      data: { additionalSensors: newSensorsList },
    }));
  };

  if (isMultipleSensors) {
    return (
      <div className="text-muted">
        To include the latest reading from other sensors in an alert notification,
        you can link &quot;additional sensors&quot; to any single alert. Because you are about to
        generate multiple alerts, you cannot select additional sensors here; however,
        you may edit individual alerts after they&apos;ve been created.
      </div>
    );
  }

  return (
    <>
      {additionalSensors.length === 0 ? (
        <div className="text-muted mb-3 font-italic">
          To include the latest reading from other sensors in your alert notifications,
          you can link &quot;additional sensors&quot; to your alert.
        </div>
      ) : (
        <div className="mb-3">
          {additionalSensors.map((sensorKey, index) => (
            <AdditionalSensor
              key={`${sensorKey.macAddress}_${index}`}
              channelKey={new ChannelKey(sensorKey)}
              onRemove={() => handleRemoveSensor(index)}
            />
          ))}
        </div>
      )}

      <Button
        variant="secondary"
        onClick={() => setShowAddSensorModal(true)}
        size="sm"
      >
        <FontAwesomeIcon icon={faPlus} className="mr-2" />
        Add Sensor
      </Button>

      <AddAdditionalSensorModal
        show={showAddSensorModal}
        onHide={() => setShowAddSensorModal(false)}
        onAdd={handleAddSensor}
      />
    </>
  );
}

export default AlertFormAdditionalSensors;
